var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"settings",staticClass:"settings"},[_c('div',{staticClass:"caret",on:{"click":_vm.openSettings}},[_c('i',{staticClass:"fa fa-sliders"})]),_c('div',{staticClass:"buttons"},[_vm._t("default",null,{"toggleSettings":_vm.openSettings})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }